import { z } from '@betty/toolkit/api';

export const StatusSchema = z.enum([
  'Member',
  'Amethyst',
  'Topaz',
  'Aquamarine',
  'Opal',
  'Emerald',
  'Ruby',
  'Sapphire',
  'Diamond',
  'Vip',
]);

const MilestoneRewardSchema = z.object({
  numberOfRewards: z.number(),
  rewardAmount: z.number(),
  qualificationAmount: z.number(),
  rewardType: z.enum(['Prize', 'MilestoneFlip']),
});

export const MilestoneSchema = z.object({
  id: z.number(),
  threshold: z.number(),
  rewardAmount: z.number(),
  rewardType: z.literal('Coins'),
  status: z.enum(['RewardPending', 'Completed']).optional(),
  label: z.string(),
  contributorsCount: z.number(),
  totalContributions: z.number().optional(),
  isRewardsListApproved: z.boolean().optional(),
  jackpotWinnerScreenName: z.string().optional(),
  jackpotWinnerStatus: StatusSchema.optional(),
  rewardStrategyName: z.string().optional(),
  prizes: z.array(MilestoneRewardSchema),
});

export const PlayerCommuntiyEventSchema = z.object({
  id: z.number(),
  label: z.string(),
  endDate: z.string(),
  startDate: z.string(),
  showUntil: z.string().optional(),
  totalContributions: z.number(),
  milestones: z.array(MilestoneSchema),
  rewardWonUrl: z.string().optional(),
  titleImageUrl: z.string().optional(),
  jackpotWonUrl: z.string().optional(),
  milestoneReachedGlowUrl: z.string().optional(),
  progressBarBackgroundUrl: z.string().optional(),
  progressBarTotalContributionsHolderUrl: z.string().optional(),
  tnCPageSwiperPhoneOneWebUrl: z.string().optional(),
  tnCPageSwiperPhoneTwoWebUrl: z.string().optional(),
  tnCPageSwiperPhoneThreeWebUrl: z.string().optional(),
  tnCPageSwiperPhoneOneMobileUrl: z.string().optional(),
  tnCPageSwiperPhoneTwoMobileUrl: z.string().optional(),
  tnCPageSwiperPhoneThreeMobileUrl: z.string().optional(),
  tnCPageMeterUrl: z.string().optional(),
});

export const PlayerCommunityEventRewardSchema = z.object({
  rewardId: z.number(),
  rewardType: z.enum([
    'CommunityEventJackpotReward',
    'CommunityEventPlayerContributionReward',
    'CommunityEventPlayerMilestoneFlipReward',
  ]),
  expiryDate: z.string().optional(),
  rewardAmount: z.number(),
  milestoneId: z.number(),
});

export const CommunityJackpotEventsSchema = z.object({
  playerCommuntiyEvents: z.array(PlayerCommuntiyEventSchema),
  playerCommunityEventRewards: z.array(PlayerCommunityEventRewardSchema),
});

export const ClaimCommunityEventRewardsSchema = z.object({}).optional();
